export class ChangePasswordModel {
  constructor(public OldPassword: string,
              public NewPassword: string,
              public ConfirmPassword: string) {
  }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/models/change-password/change-password.model.ts